import { useEffect } from "react";

/**
 * Trustpilot TrustBox widget.
 * Activate by setting REACT_APP_TRUSTPILOT_BUSINESS_ID in .env once you create the
 * Trustpilot business account at https://business.trustpilot.com/
 *
 * Variants (templateId is the Trustpilot widget type):
 *  - "5419b6ffb0d04a076446a9af" → Mini (5 stars + reviews count, small)
 *  - "5419b637fa0340045cd0c936" → Carousel (homepage hero)
 *  - "53aa8807dec7e10d38f59f32" → Quote (testimonial card)
 *
 * If REACT_APP_TRUSTPILOT_BUSINESS_ID is not set, renders nothing (so the site
 * stays clean during setup).
 */
export const isTrustpilotEnabled = () => !!process.env.REACT_APP_TRUSTPILOT_BUSINESS_ID;

const TrustpilotWidget = ({ variant = "mini", className = "" }) => {
  const businessId = process.env.REACT_APP_TRUSTPILOT_BUSINESS_ID;
  const domain = process.env.REACT_APP_TRUSTPILOT_DOMAIN || "arabellgroup.com";

  useEffect(() => {
    if (!businessId) return;
    // Inject the Trustpilot bootstrap script once
    if (document.getElementById("tp-bootstrap")) return;
    const s = document.createElement("script");
    s.id = "tp-bootstrap";
    s.src = "//widget.trustpilot.com/bootstrap/v5/tp.widget.bootstrap.min.js";
    s.async = true;
    document.head.appendChild(s);
  }, [businessId]);

  if (!businessId) return null;

  const templates = {
    mini: { id: "5419b6ffb0d04a076446a9af", height: "24px" },
    micro: { id: "5419b732fbfb950b10de65e5", height: "20px" },
    carousel: { id: "53aa8912dec7e10d38f59f36", height: "240px" },
    quote: { id: "53aa8807dec7e10d38f59f32", height: "180px" },
    list: { id: "539ad60defb9600b94d7df2c", height: "500px" },
  };
  const tpl = templates[variant] || templates.mini;

  return (
    <div
      className={`trustpilot-widget ${className}`}
      data-locale="it-IT"
      data-template-id={tpl.id}
      data-businessunit-id={businessId}
      data-style-height={tpl.height}
      data-style-width="100%"
      data-theme="dark"
      data-stars="4,5"
      data-review-languages="it,en,es,fr,de"
      data-testid="trustpilot-widget"
    >
      <a href={`https://www.trustpilot.com/review/${domain}`} target="_blank" rel="noopener noreferrer">
        Recensioni verificate su Trustpilot
      </a>
    </div>
  );
};

export default TrustpilotWidget;
